export default {
  attachmentsWrapper: {
    marginBottom: '16px',
    padding: '12px',
    border: (theme) => `1px solid ${theme.palette.grays.gray200}`,
    borderRadius: '8px',
    backgroundColor: (theme) => theme.palette.grays.gray50,
  },
  attachmentsTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: (theme) => theme.palette.grays.gray700,
    marginBottom: '8px',
  },
  attachmentsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  attachmentItem: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '8px',
    padding: '8px',
    backgroundColor: (theme) => theme.palette.white.paper,
    borderRadius: '6px',
    border: (theme) => `1px solid ${theme.palette.grays.gray200}`,
  },
  attachmentIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.grays.gray500,
  },
  attachmentName: {
    fontSize: '14px',
    color: (theme) => theme.palette.grays.gray700,
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexDirection: 'column',
  },
};
